import Vue from "vue";
import VueRouter, { Route } from "vue-router";
import SignIn from "@/views/SignIn.vue";
import SignUp from "@/views/SignUp.vue";
import ForgotPassword from "@/views/ForgotPassword.vue";
import GroupsEdit from "@/views/GroupsEdit.vue";
import GroupsShow from "@/views/GroupsShow.vue";
import UsersEdit from "@/views/UsersEdit.vue";
import ResetPassword from "@/views/ResetPassword.vue";
import { AuthRepository } from "@ct/auth";
import GroupsAttendance from "@/views/GroupsAttendance.vue";
import FacilitatorVideo from "@/views/FacilitatorVideo.vue";
import { FACILITATOR_VIDEO_CONFIG } from "@/components/FacilitatorVideoConfig";
import { RoleEnum } from "@/graphql/generatedTypes/globalTypes";
import AdminManagementPortal from "@/views/AdminManagementPortal.vue";
import MyGroupsIndex from "@/components/MyGroupsIndex.vue";
import GroupCourse from "@/components/GroupCourse.vue";

Vue.use(VueRouter);

export function trainerOrAboveCheck(to: Route, from: Route, next: Function): void {
  if (AuthRepository.getCurrentUser() === null) {
    next("/sign-in");
  } else if (AuthRepository.getCurrentUser()?.hasPermissionLevelOrGreater(RoleEnum.TRAINER)) {
    next();
  } else {
    next("/");
  }
}

export function loggedInUserCheck(to: Route, from: Route, next: Function): void {
  if (AuthRepository.getCurrentUser() === null) {
    next("/sign-in");
  } else {
    next();
  }
}

const routes = [
  {
    path: "/",
    name: "root_path",
    component: SignIn
  },
  {
    path: "/sign-in",
    name: "sign_in_path",
    component: SignIn
  },
  {
    path: "/sign-up",
    name: "sign_up_path",
    component: SignUp
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPassword
  },
  {
    path: "/contact",
    name: "contact_path",
    beforeEnter() {
      window.location.href = `${process.env.VUE_APP_CT_URL}/contact` ?? "";
    }
  },
  {
    path: "/groups/:id/edit",
    name: "groups_edit_path",
    component: GroupsEdit,
    beforeEnter: trainerOrAboveCheck
  },
  {
    path: "/groups/new",
    name: "groups_new_path",
    component: GroupsEdit,
    beforeEnter: trainerOrAboveCheck
  },
  {
    path: "/groups/:id",
    name: "group_path",
    component: GroupsShow
  },
  {
    path: "/my-group/:id",
    name: "my_group_path",
    component: GroupCourse,
    beforeEnter: loggedInUserCheck
  },
  {
    path: "/users/:id/edit",
    name: "users_edit_path",
    component: UsersEdit,
    beforeEnter: loggedInUserCheck
  },
  {
    path: "/users/:userId/groups",
    name: "users_group_path",
    component: MyGroupsIndex,
    beforeEnter: loggedInUserCheck
  },
  {
    path: "/password_resets/:token/edit",
    name: "reset_password_path",
    component: ResetPassword
  },
  {
    path: "/admin-management_portal",
    name: "admin_management_portal_path",
    component: AdminManagementPortal,
    beforeEnter: trainerOrAboveCheck
  },
  {
    path: "/group/:id/group_members",
    name: "group_members_path",
    component: GroupsAttendance,
    beforeEnter: trainerOrAboveCheck
  },
  {
    path: "/facilitator-video/:id",
    name: "facilitator_video_path",
    component: FacilitatorVideo,
    props: (route: Route) => ({
      id: parseInt(route.params.id),
      config: FACILITATOR_VIDEO_CONFIG
    }),
    beforeEnter: trainerOrAboveCheck
  },
  {
    path: "/privacy",
    name: "privacy_path",
    beforeEnter() {
      window.location.href = `${process.env.VUE_APP_CT_URL}/privacy` ?? "";
    }
  },
  {
    path: "/success",
    name: "success_path",
    component: GroupsShow,
    beforeEnter() {
      window.location.href = process.env.VUE_APP_HSLP_URL ?? "";
    }
  },
  {
    path: "/about",
    name: "about_path",
    beforeEnter() {
      window.location.href = process.env.VUE_APP_CT_URL ?? "";
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(current, previous) {
    if (current.path == previous.path) {
      return;
    }
    return { x: 0, y: 0 };
  }
});

export default router;
